import { ApplicationRef, ComponentFactoryResolver, EmbeddedViewRef, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { AppService } from '../../app.service';
import { SnackbarComponent } from '../components/snackbar/snackbar.component';
import { UploadedFile } from '../models/uploaded-file.model';
import { StudiosHttpClientService } from './studios-http-client.service';

@Injectable()
export class UtilitiesService {

  private baseUrl: string;

  constructor(
    private appService: AppService,
    private studiosHttpClient: StudiosHttpClientService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private applicationRef: ApplicationRef,
    private injector: Injector
  ) {
    this.baseUrl = this.appService.utilsUrls.apiUrl;
  }

  public uploadFile(formData: FormData, loaderId?: string): Observable<UploadedFile[]> {
    const url = this.baseUrl + '/Common/UploadFiles';
    return this.studiosHttpClient.post<UploadedFile[]>(url, formData, {}, loaderId);
  }

  public showSnackbar(message: string, milliseconds?: number) {
    if (!milliseconds) { milliseconds = 3500; }
    const componentRef = this.componentFactoryResolver.resolveComponentFactory(SnackbarComponent).create(this.injector);
    componentRef.instance.message = message;
    this.applicationRef.attachView(componentRef.hostView);
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
    setTimeout(() => { componentRef.instance.show = true; });
    setTimeout(() => {
      componentRef.instance.show = false;
      setTimeout(() => {
        this.applicationRef.detachView(componentRef.hostView);
        componentRef.destroy();
      }, 2000);
    }, milliseconds);
  }
}
